(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[339],{

/***/ 8339:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]",
      function () {
        return __webpack_require__(4953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_slicezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8917);
/* harmony import */ var _utils_additional_data_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1623);
/* harmony import */ var _utils_layout_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5385);
/* harmony import */ var _sm_resolver_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7982);
/* harmony import */ var _components_Head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4394);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var Page = function(props) {
    var data = props.data, url = props.url, locale = props.locale, metaData = props.metaData;
    var setHeaderColor = (0,_utils_layout_context__WEBPACK_IMPORTED_MODULE_4__/* .useLayout */ .$Y)().setHeaderColor;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (data) setHeaderColor(data.headercolor);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Head__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                data: data,
                canonical: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_additional_data_context__WEBPACK_IMPORTED_MODULE_3__/* .AdditionalDataProvider */ .YZ, {
                value: props.additionalData,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_slicezone__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props, {
                    resolver: _sm_resolver_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
                }))
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,430,100,931,675,226,416,774,888,179], function() { return __webpack_exec__(8339); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);